import { toDisplayString as _toDisplayString, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b21dae08")

_pushScopeId("data-v-b21dae08")
const _hoisted_1 = { class: "button-bgd" }
const _hoisted_2 = { class: "button-vector" }
const _hoisted_3 = { class: "loader" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("button", {
    class: ["btn btn-round-rect", [_ctx.isPushed || _ctx.disable ? 'pushed-color' : null]],
    disabled: _ctx.disable
  }, [
    _createVNode("div", _hoisted_1, [
      _withDirectives(_createVNode("span", { class: "button-text txt txt-small txt-wt" }, _toDisplayString(_ctx.text), 513), [
        [_vShow, !_ctx.isPushed]
      ]),
      _createVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _withDirectives(_createVNode("div", _hoisted_3, null, 512), [
      [_vShow, _ctx.isPushed]
    ])
  ], 10, ["disabled"]))
})